import DOMPurify from 'dompurify';

function normalizeVisibleText(value: string | null | undefined): string {
  return (value ?? '')
    .replace(/\u00a0/g, ' ')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .trim();
}

function extractTextFromHtml(html: string): string {
  const sanitizedHtml = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });

  if (typeof DOMParser === 'undefined') {
    return sanitizedHtml.replace(/<[^>]*>/g, ' ');
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitizedHtml, 'text/html');
  return doc.body.textContent ?? '';
}

export function hasVisibleHtmlContent(
  html: string | null | undefined,
): boolean {
  if (!normalizeVisibleText(html)) {
    return false;
  }

  return normalizeVisibleText(extractTextFromHtml(html ?? '')).length > 0;
}
